// extracted by mini-css-extract-plugin
export default {"modalLink":"QixIsPfCIowd5HxC5i7Wfg==","needRow":"S9BXsMUiwWnGhtuSxrMISA==","needData":"bodBPB5J+JlfSe5d5GX2Yw=="};